import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Flex } from "antd";
import {
  FormInput,
  FormDatePicker,
  AppForm,
  LanguageSelect,
  SettingsSectionTitle,
} from "@/shared/Components";
import { installationConfig } from "@/shared/constants/installation-config";
import { useProfileForm } from "../model";
import styles from "./styles.module.scss";

export const ProfileForm = () => {
  const { t } = useTranslation();
  const { formApi } = useProfileForm();

  return (
    <Flex className={styles.root} vertical gap={12}>
      <SettingsSectionTitle title={t("settingsPage.general.personalInfo")} />
      <AppForm formApi={formApi} onSubmit={() => {}} className={styles["info-inputs"]}>
        <FormInput
          className={styles.input}
          name="firstName"
          placeholder={t("registrationPage.userInfoStep.firstName")}
          disabled
        />
        <FormInput
          className={styles.input}
          name="lastName"
          placeholder={t("registrationPage.userInfoStep.lastName")}
          disabled
        />
        <FormInput
          className={styles.input}
          name="mobilePhone"
          placeholder={t("settingsPage.general.phone")}
          disabled
        />
        <FormInput
          className={styles.input}
          name="email"
          placeholder={t("settingsPage.general.email")}
          disabled
        />
        <Flex>
          <FormDatePicker
            className={classNames(styles["birthday-select"], styles.input)}
            placeholder={t("settingsPage.general.birthday")}
            name="birthday"
            disabled
          />
          {installationConfig.name === "Umarta" && <LanguageSelect />}
        </Flex>
      </AppForm>
    </Flex>
  );
};
